<template>
  <div class="pick-batch" v-loading="loading">
    <div class="row pick-batch__toolbar">
      <div class="form-group col-sm-9 form-inline">
        <div class="input-group has-feedback pick-batch__date">
          <span class="input-group-addon">日期</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="small"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="采样日期范围"
            end-placeholder=""
            unlink-panels
            clearable
            class="pick-batch__date-picker"
          />
        </div>

        <div class="input-group pick-batch__kw">
          <span class="input-group-addon">关键字</span>
          <input
            v-model="keyword"
            type="text"
            class="form-control"
            placeholder="任务名、编号、地址"
            @keyup.enter="query"
          />
        </div>

        <div class="input-group">
          <span class="input-group-addon">类型</span>
          <select v-model="inspectSubType" class="form-control">
            <option value="">全部</option>
            <option v-for="t in subTypeOptions" :key="t" :value="t">{{ t }}</option>
          </select>
        </div>

        <div class="input-group">
          <span class="input-group-addon">周期</span>
          <select v-model="cycleType" class="form-control">
            <option value="">全部</option>
            <option v-for="t in cycleOptions" :key="t" :value="t">{{ t }}</option>
          </select>
        </div>

        <div class="input-group pick-batch__freq">
          <span class="input-group-addon">期数</span>
          <input v-model="freqPickIndex" type="text" class="form-control" placeholder="第几期" @keyup.enter="query" />
        </div>
      </div>

      <div class="form-group col-sm-3">
        <div class="input-group pick-batch__actions">
          <button class="btn btn-sm btn-primary" type="button" @click="query">
            <i class="fa fa-search" />查询
          </button>
          <button class="btn btn-sm btn-info" type="button" @click="sendClick">
            <i class="fa fa-send" />提交至：{{ nextNodeName }}
          </button>
        </div>
      </div>
    </div>

    <div class="panel panel-default pick-batch__panel">
      <div class="panel-heading">
        <span>勾选任务并设置：</span>
        <button class="btn btn-link btn-sm" type="button" @click="batchSetCharge">采样负责人</button>
        <button class="btn btn-link btn-sm" type="button" @click="batchSetMembers">采样组员</button>
        <button class="btn btn-link btn-sm" type="button" @click="batchSetDate">采样日期</button>
        <button class="btn btn-link btn-sm" type="button" @click="batchSetInstrument">采样仪器</button>
        <button class="btn btn-link btn-sm" type="button" @click="batchSetVehicle">车辆安排</button>
      </div>

      <div class="pick-batch__table-wrap">
        <table class="table table-bordered table-striped pick-batch__table">
          <thead>
            <tr>
              <th style="width:36px;min-width:36px;" />
              <th style="min-width:120px;">任务名称</th>
              <th style="min-width:120px;">采样类型</th>
              <th style="min-width:120px;">采样项目</th>
              <th style="min-width:120px;">采样点位</th>
              <th style="min-width:120px;">详细地址</th>
              <th style="min-width:120px;">采样人员</th>
              <th style="min-width:120px;">任务周期</th>
              <th style="min-width:120px;">采样日期</th>
              <th style="min-width:140px;">采样仪器</th>
              <th style="min-width:100px;">车牌号</th>
              <th style="min-width:120px;">采样频次</th>
              <th style="min-width:120px;">任务状态</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in viewList"
              :key="row.id"
              :class="{ 'is-selected': row.selected }"
              @click="toggleRowSelect(row)"
            >
              <td @click.stop>
                <input
                  type="checkbox"
                  v-model="row.selected"
                  :disabled="isArrangeLocked(row)"
                  :title="isArrangeLocked(row) ? '已完成采样，不可再改安排' : ''"
                />
              </td>
              <td>
                <div class="small">{{ row.projectCode }}</div>
                <div>
                  <a href="javascript:;" title="点击查看任务流程明细" @click.prevent.stop="openRow(row)">
                    {{ row.caseName }}
                  </a>
                </div>
              </td>
              <td>{{ row.inspectSubType }}</td>
              <td>{{ row.inspectItems }}</td>
              <td>{{ row.monitorPlace }}</td>
              <td>{{ row.address }}</td>
              <td>
                <span v-if="row.pickCharge || row.pickMembers">
                  <template v-if="row.pickCharge">{{ row.pickCharge }}</template>
                  <template v-if="row.pickCharge && row.pickMembers">; </template>
                  <template v-if="row.pickMembers">{{ row.pickMembers }}</template>
                </span>
              </td>
              <td>{{ row.cycleType }}</td>
              <td>{{ row.pickDateLabel }}</td>
              <td>
                <span class="pick-batch__cell-wrap" :title="row.instruments || ''">{{ row.instruments || '—' }}</span>
              </td>
              <td>{{ row.vehiclePlate || '—' }}</td>
              <td>{{ row.frequency }}</td>
              <td>
                <span :class="{ 'text-success': row.status === '待安排采样' }">{{ row.status }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!viewList.length" class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
      </div>
    </div>

    <el-dialog
      title="批量设置采样负责人"
      :visible.sync="chargeDlg"
      width="420px"
      append-to-body
      custom-class="yn-pick-dlg"
      @closed="onPickDlgClosed"
    >
      <el-select
        ref="chargeSelect"
        v-model="batchCharge"
        filterable
        clearable
        placeholder="选择采样负责人"
        style="width:100%"
        :popper-append-to-body="false"
      >
        <el-option v-for="u in users" :key="'c-' + u.id" :label="u.xm" :value="String(u.id)" />
      </el-select>
      <div slot="footer">
        <el-button @click="chargeDlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="confirmCharge">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量设置采样组员"
      :visible.sync="memberDlg"
      width="420px"
      append-to-body
      custom-class="yn-pick-dlg"
      @closed="onPickDlgClosed"
    >
      <el-select
        ref="memberSelect"
        v-model="batchMembers"
        multiple
        filterable
        clearable
        placeholder="选择采样组员"
        style="width:100%"
        :popper-append-to-body="false"
      >
        <el-option v-for="u in users" :key="'m-' + u.id" :label="u.xm" :value="String(u.id)" />
      </el-select>
      <div slot="footer">
        <el-button @click="memberDlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="confirmMembers">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量设置采样日期"
      :visible.sync="dateDlg"
      width="420px"
      append-to-body
      custom-class="yn-pick-dlg"
      @closed="onPickDlgClosed"
    >
      <el-date-picker
        v-model="batchDate"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:100%"
        :append-to-body="false"
      />
      <div slot="footer">
        <el-button @click="dateDlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="confirmDate">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="车辆安排 · 选择车牌"
      :visible.sync="vehicleDlg"
      width="420px"
      append-to-body
      custom-class="yn-pick-dlg"
      @closed="onPickDlgClosed"
    >
      <el-select
        ref="vehicleSelect"
        v-model="batchPlate"
        filterable
        allow-create
        default-first-option
        clearable
        placeholder="选择或输入车牌号"
        style="width:100%"
        :popper-append-to-body="false"
      >
        <el-option v-for="p in plateOptions" :key="p" :label="p" :value="p" />
      </el-select>
      <p class="text-muted" style="margin:10px 0 0;font-size:12px;">可从列表选择，也可直接输入自定义车牌</p>
      <div slot="footer">
        <el-button @click="vehicleDlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="confirmVehicle">确定</el-button>
      </div>
    </el-dialog>

    <PickInstrumentPicker v-model="instDlg" @pick="onInstrumentsPicked" />
  </div>
</template>

<script>
import api from '@/utils/api'
import { isPickSampler } from '@/utils/user'
import PickInstrumentPicker from '@/components/ivan/PickInstrumentPicker.vue'
import {
  fetchPickRows,
  filterPickRows,
  uniqueSubTypes,
  uniqueCycleTypes,
  patchPickFields,
  markPickSubmitted,
  IVAN_INSPECT_SUB_TYPES,
  PICK_VEHICLE_PLATES,
  formatPickedInstruments,
  flushPickArrangeToServer,
  validatePickArrangeReady,
  isPickArrangeLocked
} from '@/utils/pickAdapter'

export default {
  name: 'PickBatchArrange',
  components: { PickInstrumentPicker },
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      viewList: [],
      keyword: '',
      dateRange: null,
      inspectSubType: '',
      cycleType: '',
      freqPickIndex: '',
      nextNodeName: '采样提交',
      users: [],
      chargeDlg: false,
      memberDlg: false,
      dateDlg: false,
      instDlg: false,
      vehicleDlg: false,
      batchCharge: '',
      batchMembers: [],
      batchDate: null,
      batchPlate: '',
      plateOptions: PICK_VEHICLE_PLATES.slice(),
      batchTargetIds: []
    }
  },
  computed: {
    subTypeOptions() {
      const fromData = uniqueSubTypes(this.rows).filter(Boolean)
      return fromData.length ? fromData : IVAN_INSPECT_SUB_TYPES
    },
    cycleOptions() {
      return uniqueCycleTypes(this.rows).filter(Boolean)
    },
    selected() {
      return this.viewList.filter(r => r.selected)
    }
  },
  mounted() {
    this.load()
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      try {
        const res = await api.get('yn_yh_list')
        this.users = (res.data || []).filter(u => u.zt == 1 && isPickSampler(u))
      } catch (e) {
        this.users = []
      }
    },
    async load() {
      this.loading = true
      try {
        this.rows = await fetchPickRows()
        this.applyFilter()
        // 把本地已选仪器/车牌补同步到服务端，135 才能灌交通工具
        await flushPickArrangeToServer(this.rows)
        this.applyFilter()
      } catch (e) {
        this.rows = []
        this.viewList = []
        this.$message.error('加载采样任务失败')
      } finally {
        this.loading = false
      }
    },
    applyFilter() {
      const [dateFrom, dateTo] = this.dateRange || []
      this.viewList = filterPickRows(this.rows, {
        keyword: this.keyword,
        dateFrom,
        dateTo,
        inspectSubType: this.inspectSubType,
        cycleType: this.cycleType,
        freqPickIndex: this.freqPickIndex
      })
    },
    query() {
      this.applyFilter()
    },
    openRow(row) {
      if (row.xmbh) this.$router.push({ path: '/pick/batch-contract', query: { xmbh: row.xmbh } })
      else this.$router.push('/pick/doing')
    },
    ensureSelected() {
      this.viewList.forEach(r => {
        if (r && r.selected && this.isArrangeLocked(r)) r.selected = false
      })
      if (!this.selected.length) {
        this.$message.warning('请先勾选需要设置的采样任务！')
        return false
      }
      if (this.selected.some(r => this.isArrangeLocked(r))) {
        this.$message.warning('已完成采样的任务不可再改安排信息')
        return false
      }
      return true
    },
    isArrangeLocked(row) {
      return isPickArrangeLocked(row)
    },
    toggleRowSelect(row) {
      if (!row || this.isArrangeLocked(row)) return
      row.selected = !row.selected
    },
    lockBatchTargets() {
      this.batchTargetIds = this.selected.filter(r => !this.isArrangeLocked(r)).map(r => String(r.id))
      return this.batchTargetIds.length > 0
    },
    resolveBatchTargets() {
      const ids = new Set((this.batchTargetIds || []).map(String))
      if (!ids.size) return this.selected.filter(r => !this.isArrangeLocked(r))
      const fromView = this.viewList.filter(r => ids.has(String(r.id)) && !this.isArrangeLocked(r))
      if (fromView.length) return fromView
      return this.rows.filter(r => ids.has(String(r.id)) && !this.isArrangeLocked(r))
    },
    batchSetCharge() {
      if (!this.ensureSelected()) return
      this.lockBatchTargets()
      this.batchCharge = ''
      this.chargeDlg = true
    },
    batchSetMembers() {
      if (!this.ensureSelected()) return
      this.lockBatchTargets()
      this.batchMembers = []
      this.memberDlg = true
    },
    batchSetDate() {
      if (!this.ensureSelected()) return
      this.lockBatchTargets()
      this.batchDate = null
      this.dateDlg = true
    },
    batchSetInstrument() {
      if (!this.ensureSelected()) return
      this.lockBatchTargets()
      this.instDlg = true
    },
    batchSetVehicle() {
      if (!this.ensureSelected()) return
      this.lockBatchTargets()
      this.batchPlate = ''
      this.vehicleDlg = true
    },
    onPickDlgClosed() {
      ;['chargeSelect', 'memberSelect', 'vehicleSelect'].forEach((name) => {
        const sel = this.$refs[name]
        if (sel && typeof sel.blur === 'function') sel.blur()
        if (sel && sel.visible) sel.visible = false
      })
      // 清掉偶发残留在 body 上的下拉层
      try {
        document.querySelectorAll('body > .el-select-dropdown').forEach((el) => {
          if (el && el.parentNode) el.parentNode.removeChild(el)
        })
      } catch (e) { /* ignore */ }
    },
    async confirmCharge() {
      if (!this.batchCharge) {
        this.$message.warning('请选择采样负责人')
        return
      }
      const targets = this.resolveBatchTargets()
      if (!targets.length) {
        this.$message.warning('勾选已失效，请重新勾选任务后再设置')
        return
      }
      const u = this.users.find(x => String(x.id) === String(this.batchCharge))
      if (!u) {
        this.$message.warning('用户无效')
        return
      }
      this.chargeDlg = false
      this.saving = true
      try {
        for (const row of targets) {
          await patchPickFields(row, { cyfzr: u.xm, cyfzr_id: u.id })
          this.$set(row, 'pickCharge', u.xm)
          row.sj = { ...(row.sj || {}), cyfzr: u.xm }
          row.selected = true
        }
        this.$message.success('已保存（点提交后才会下发 App）')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async confirmMembers() {
      if (!this.batchMembers.length) {
        this.$message.warning('请选择采样组员')
        return
      }
      const targets = this.resolveBatchTargets()
      if (!targets.length) {
        this.$message.warning('勾选已失效，请重新勾选任务后再设置')
        return
      }
      const picked = this.batchMembers
        .map(id => this.users.find(x => String(x.id) === String(id)))
        .filter(Boolean)
      if (!picked.length) {
        this.$message.warning('用户无效')
        return
      }
      const text = picked.map(u => u.xm).join(';')
      const ids = picked.map(u => String(u.id))
      this.memberDlg = false
      this.saving = true
      try {
        for (const row of targets) {
          await patchPickFields(row, { cyry: text, cyry_ids: ids })
          this.$set(row, 'pickMembers', text)
          this.$set(row, 'pickStaff', text)
          row.sj = { ...(row.sj || {}), cyry: text }
          row.selected = true
        }
        this.$message.success('已保存（点提交后才会下发 App）')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async confirmDate() {
      if (!this.batchDate || !this.batchDate.length) {
        this.$message.warning('请选择日期')
        return
      }
      const targets = this.resolveBatchTargets()
      if (!targets.length) {
        this.$message.warning('勾选已失效，请重新勾选任务后再设置')
        return
      }
      const [from, to] = this.batchDate
      this.dateDlg = false
      this.saving = true
      try {
        for (const row of targets) {
          await patchPickFields(row, { cyrq_from: from, cyrq_to: to || from, yqwcsj: from })
          const pad = (d) => {
            const s = String(d).slice(0, 10)
            return `${s.slice(5, 7)}月${s.slice(8, 10)}日`
          }
          const label = (!to || to === from) ? pad(from) : `${pad(from)}~${pad(to)}`
          this.$set(row, 'pickDateFrom', from)
          this.$set(row, 'pickDateTo', to || from)
          this.$set(row, 'pickDateLabel', label)
          row.sj = { ...(row.sj || {}), cyrq_from: from, cyrq_to: to || from }
          row.selected = true
        }
        this.$message.success('已成功保存')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async onInstrumentsPicked(payload) {
      const text = formatPickedInstruments(payload)
      if (!text) {
        this.$message.warning('请选择采样仪器')
        return
      }
      const targets = this.resolveBatchTargets()
      if (!targets.length) {
        this.$message.warning('勾选已失效，请重新勾选任务后再设置')
        return
      }
      this.saving = true
      try {
        for (const row of targets) {
          await patchPickFields(row, { cyyq: text })
          this.$set(row, 'instruments', text)
          row.sj = { ...(row.sj || {}), cyyq: text }
          row.selected = true
        }
        this.$message.success('已成功保存')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async confirmVehicle() {
      const plate = String(this.batchPlate || '').trim()
      if (!plate) {
        this.$message.warning('请选择或输入车牌号')
        return
      }
      const targets = this.resolveBatchTargets()
      if (!targets.length) {
        this.$message.warning('勾选已失效，请重新勾选任务后再设置')
        return
      }
      this.vehicleDlg = false
      this.saving = true
      try {
        for (const row of targets) {
          await patchPickFields(row, { cph: plate })
          this.$set(row, 'vehiclePlate', plate)
          row.sj = { ...(row.sj || {}), cph: plate }
          row.selected = true
        }
        this.$message.success('已成功保存')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async sendClick() {
      if (!this.ensureSelected()) return
      const gate = validatePickArrangeReady(this.selected)
      if (!gate.ok) {
        this.$message.warning(gate.message || '请先完善安排信息')
        return
      }
      try {
        await this.$confirm(`确认将 ${this.selected.length} 条任务提交至「${this.nextNodeName}」？`, '提交确认', {
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this.saving = true
      try {
        const results = await markPickSubmitted(this.selected)
        const bad = (results || []).find(r => r && r.ok === 0)
        if (bad) {
          this.$message.error(bad.error || '同步 App 失败')
          return
        }
        const ids = new Set(this.selected.map(r => r.id))
        this.rows = this.rows.filter(r => !ids.has(r.id))
        this.applyFilter()
        this.$message.success('已提交，采样员可在 App「采样信息」看到')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.pick-batch {
  height: 100%;
  background: #fff;
  padding: 4px 8px 12px;
  overflow: auto;
}
.pick-batch__toolbar {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 4px;
}
.pick-batch .input-group {
  display: inline-flex;
  align-items: center;
  margin: 0 8px 8px 0;
  vertical-align: middle;
}
.pick-batch .input-group-addon {
  background: transparent;
  border: none;
  padding: 0 6px 0 0;
  color: #333;
  white-space: nowrap;
  width: auto;
}
.pick-batch .form-control {
  height: 30px;
  border-radius: 4px;
  min-width: 100px;
}
.pick-batch__date {
  width: 293px;
}
.pick-batch__date-picker {
  width: 220px !important;
}
.pick-batch__kw {
  width: 225px;
}
.pick-batch__kw .form-control {
  width: 160px;
}
.pick-batch__freq {
  width: 120px;
}
.pick-batch__freq .form-control {
  width: 72px;
}
.pick-batch__actions .btn {
  margin-right: 5px;
}
.pick-batch__panel {
  height: calc(100% - 60px);
  margin-bottom: 0;
  overflow: auto;
}
.pick-batch .panel-heading {
  background: #f5f5f5;
  padding: 8px 12px;
}
.pick-batch .panel-heading .btn-link {
  padding: 0 8px;
  color: #337ab7;
}
.pick-batch__table-wrap {
  overflow: auto;
}
.pick-batch__table {
  margin-bottom: 0;
  table-layout: auto;
}
.pick-batch__table >>> th,
.pick-batch__table th {
  white-space: nowrap !important;
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  vertical-align: middle;
  font-weight: 600;
  background: #f9f9f9;
}
.pick-batch__table td {
  vertical-align: middle;
  word-break: break-word;
}
.pick-batch__cell-wrap {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.pick-batch__table tr.is-selected,
.pick-batch__table tr.is-selected > td {
  background-color: #d9edf7 !important;
}
.pick-batch__table tr.is-selected > td:first-child {
  box-shadow: inset 3px 0 0 #337ab7;
}
.pick-batch__table a {
  color: #337ab7;
}
.pick-batch__table .small {
  color: #777;
  font-size: 12px;
  line-height: 1.3;
}
.pick-batch__table td {
  vertical-align: middle;
  word-break: break-word;
  white-space: normal;
}
</style>
